export const SET_ADMIN_LOADING = "admin/SET_ADMIN_LOADING";

export const SET_DASHBOARD_TOTALS = "admin/SET_DASHBOARD_TOTALS";
export const SET_ALL_USER = "admin/SET_ALL_USER";
export const SET_ALL_PROPERTY = "admin/SET_ALL_PROPERTY";
export const SET_ALL_BOOKING = "admin/SET_ALL_BOOKING";
export const SET_ALL_AMENITY = "admin/SET_ALL_AMENITY";
export const SET_BOOKING_DETAILS = "admin/SET_BOOKING_DETAILS";
